import React, {useEffect} from 'react';
import {Button, Col, Form, Input, Row, TimePicker} from "antd";
import {useLocation} from "react-router-dom";
import {useEditQuery, useGetByIdQuery, usePostQuery} from "../../service/query/Queries";
import {EditGetById, SetInitialValue, SuccessCreateAndEdit} from "../../hooks";
import {AppLoader, FormInput} from "../../components";
import dayjs from "dayjs";



const initialValueForm = {
    startTime: "",
    endTime: "",


}
const format = 'HH:mm';

const FloorPostEdit = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const editId = queryParams.get('editId');
    const [form] = Form.useForm();
    console.log()

    const {
        mutate: postWorkTimeMutate,
        isLoading: postWorkTimeLoading,
        isSuccess: postWorkTimeSuccess

    } = usePostQuery()
    const {
        isLoading: editWorkTimeLoading,
        data: editWorkTimeData,
        refetch: editWorkTimeRefetch,
        isSuccess: editWorkTimeSuccess
    } = useGetByIdQuery(false, "edit-work-time", editId, '/work-time')
    const {
        mutate: putWorkTime,
        isLoading: putWorkTimeLoading,
        isSuccess: putWorkTimeSuccess
    } = useEditQuery()


    SuccessCreateAndEdit(postWorkTimeSuccess, putWorkTimeSuccess, '/work-time')

    EditGetById(editWorkTimeRefetch, editId)

    SetInitialValue(form, initialValueForm)


    useEffect(() => {
        if (editWorkTimeSuccess) {

            const edit = {
                startTime: editWorkTimeData?.startTime
                    ? dayjs(editWorkTimeData.startTime, format)
                    : null,

                endTime: editWorkTimeData?.endTime
                    ? dayjs(editWorkTimeData.endTime, format)
                    : null,
            }
            form.setFieldsValue(edit)
        }
    }, [editWorkTimeData])


    const onFinish = (value) => {
        const data = {
            startTime: value.startTime.format("HH:mm"),
            endTime: value.endTime.format("HH:mm"),
        }
        if (editWorkTimeData) {
            putWorkTime({url: `/work-time`, data: data, id: editId})
        } else {
            postWorkTimeMutate({url: `/work-time`, data: data});
        }
    }


    return (
        <div>
            {(postWorkTimeLoading || editWorkTimeLoading || putWorkTimeLoading) ?
                <AppLoader/> :
                <Form
                    form={form}
                    endTime="basic"
                    labelCol={{
                        span: 24
                    }}
                    wrapperCol={{
                        span: 24
                    }}
                    style={{
                        maxWidth: "100%"
                    }}
                    initialValues={initialValueForm}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={20}>


                        <Col span={12}>
                            <Form.Item
                                label={"Время начала"}
                                name={"startTime"}

                                rules={[{
                                    required: true, message: "Требуется  время"
                                }]}
                            >
                                <TimePicker
                                    style={{width: "100%"}}

                                    format={format}

                                />
                            </Form.Item>


                        </Col>
                        <Col span={12}>

                            <Form.Item
                                label={"Конец времени"}
                                name={"endTime"}

                                rules={[{
                                    required: true, message: "Требуется время"
                                }]}
                            >
                                <TimePicker
                                    style={{width: "100%"}}


                                    format={format}

                                />
                            </Form.Item>
                        </Col>


                    </Row>
                    <Button type="primary" htmlType="submit" style={{width: "100%", marginTop: "20px"}}>
                        {editWorkTimeSuccess ? 'Редактировать' : 'Создать'}
                    </Button>
                </Form>}
        </div>);
};

export default FloorPostEdit;